export default "__VITE_ASSET__bO5I$PQR__"